import { getCustomerList } from '@/api/user'

const state = {
    customerList: [],

}

const mutations = {
    SET_CUSTOMER_LIST(state, list) {
        state.customerList = list;
    }
}

const actions = {
    async getCustomerList({ commit }, ) {
        const { data } = await getCustomerList();
        data.code === 200 && commit('SET_CUSTOMER_LIST', data.data.data.data);
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
}